import { forEach, map, remove, compact, find } from 'lodash'
import { produce } from 'immer'
import { CategoryData } from '../apis/category.api'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'
export default {

  find (categories: CategoryData[], id: number) {
    return find(categories, { id })
  },

  searchOptions (categories: CategoryData[]) {
    const categoriesData = map(categories, category => {
      const { name, id } = category
      return { id, value: name }
    })
    return compact(categoriesData)
  },

  selectOptions (categories: CategoryData[]) {
    return map(categories, category => {
      const { name, id } = category
      return { name, value: String(id) }
    })
  },

  tableHorizontalData (
    categories: CategoryData[]
  ): TableHorizontalData<CategoryData>[] {
    forEach(categories, (category: TableHorizontalData<CategoryData>) => {
      const actions: ActionName[] = ['edit']
      if (!category.isDeleted) actions.push('delete')
      category.actions = actions
    })
    return categories
  },

  delete (categories: TableHorizontalData<CategoryData>[], id: number) {
    return produce(categories, categories => {
      remove(categories, { id })
    })
  }
}
